import styled, { createGlobalStyle } from "styled-components";

export const Card = styled("div")``;
export const CardBody = styled("div")``;

export const PrintPage = styled("button")`
  display: block;

  @media print {
    display: none;
  }
`;

export const ShowInPrintOnly = styled("div")`
  position: absolute;
  display: block;
  height: 0;
  width: 100%;
  opacity: 0;
  z-index: -1;

  @media print {
    position: relative;
    display: block;
    height: 100%;
    width: 100%;
    opacity: 1;
    z-index: 1;
  }
`;

export const GlobalStyle = createGlobalStyle`
  .rdt_Pagination {
    padding-left: 0;
    padding-right: 0;
    background: none;

    span {
      margin: 0px 4px;
    }

    #pagination-first-page,
    #pagination-previous-page,
    #pagination-next-page,
    #pagination-last-page {
      height: 30px;
      width: 30px;
      padding: 3px;
    }
  }

  .rdt-CustomLoader {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(3px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  .custom-table {
    height: calc(100% - 45px);
    border-radius: 0px;

    & > div {
      background: none;
      height: 100%;

      & > div.rdt_Table {
        border: 0px;
        background: none;

        .rdt_TableHead {
          background: none;

          .rdt_TableHeadRow {
            background: none;

            .rdt_TableCol {
              padding-left: 0px;
              padding-right: 0px;
            }
          }
        }

        .rdt_TableBody {
          background: none;
          height: calc(38px * 10);
          
          .rdt_TableRow {
            background: none;
            min-height: 38px;
            
            .rdt_TableCell {
              background: none;
              padding-left: 0px;
              padding-right: 0px;
            }
          }
        }

        & > div {
          background: none;
        }
      }
    }
  }

  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: always;
  }
`;
